import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from '@angular/forms';
import { SharedService } from '../../layouts/shared-service';
import { AnalysisDetails, DropDown, SearchResult } from '../../model/analysis-details.model';
import { DropDownService } from '../../service/drop-down.service';
import { AuthService, DBService } from '../../service';
import { User } from '../../model/types';
import { Router } from '@angular/router';
import { MatChipInputEvent } from '@angular/material/chips';
import { COMMA, ENTER, SPACE, } from '@angular/cdk/keycodes';
import { Moment } from 'moment';
import moment from 'moment';
import { AuthNewService } from '../../service/auth-new.service';
import { Observable } from 'rxjs';
import { delay } from 'rxjs/operators';
import { getCurrentUser } from 'aws-amplify/auth';



@Component({
  selector: 'app-new-analysis',
  templateUrl: './new-analysis.component.html',
  styleUrls: ['./new-analysis.component.scss'],
  standalone: false
})
export class NewAnalysisComponent implements OnInit {



  pageTitle = 'Analyze Report/Data';
  signedInUser: User;
  analysisFormGroup: FormGroup;
  Groups: any[] = [];
  visible = true;
  selectable = true;
  removable = true;

  analysisTypeOptions = [
    { name: 'INS', desc: 'In-Study Analysis' },
    { name: 'QV', desc: 'Qualification or Validation' }
  ];
  workflowTypeOptions = [
    { name: 'clinVal', desc: 'Clinical Validation' },
    { name: 'clinQual', desc: 'Clinical Qualification' },
    { name: 'nonClinVal', desc: 'Non-Clinical Validation' }
  ];
  fprOptions = ['5%', '1%'];


  // analytes: FormArray
  analysisDetails: AnalysisDetails;

  post: any = '';

  readonly separatorKeysCodes: number[] = [ENTER, COMMA, SPACE];

  Tags: string[] = [];
  maxDate;
  multipleAnalyteError = false;

  addOnBlur = true;
  // optionsSACodes = [];
  // optionsMVCodes = [];
  // filteredOptionsSA: Observable<string[]>;
  // filteredOptionsMV: Observable<string[]>;


  constructor(private formBuilder: FormBuilder,
    private _sharedService: SharedService,
    private authService: AuthNewService,
    private router: Router,
    private dbService: DBService,
    private dropDownService: DropDownService,
    private newAuthService: AuthNewService,
    private ref: ChangeDetectorRef) {

    this._sharedService.emitChange(this.pageTitle);
  }

  ngOnInit() {
    const currentDate = moment().toDate();
    this.maxDate = currentDate;
    getCurrentUser().then(data => {
      this.signedInUser = new User(true, data.username, data.userId);
    }).catch(e => {
      this.router.navigate(['/extra-layout/signin']);
      return;
    });
    this.newAuthService.getGroups();
    this.authService.userGroup.pipe(delay(1000)).subscribe((group) => {
      this.Groups.push(group)
    })
    this.createForm();

    this.analysisFormGroup.get('calcType').valueChanges.subscribe(calcType => {
      this.analysisTypeOptions = calcType === 'Sensitivity'
        ? [{ name: 'QV', desc: 'Qualification or Validation' }]
        : [{ name: 'INS', desc: 'In-Study Analysis' }, { name: 'QV', desc: 'Qualification or Validation' }];
      this.workflowTypeOptions = calcType === 'Sensitivity'
        ? [{ name: 'clinVal', desc: 'Clinical Validation' }, { name: 'clinQual', desc: 'Clinical Qualification' }]
        : [{ name: 'clinVal', desc: 'Clinical Validation' }, { name: 'clinQual', desc: 'Clinical Qualification' },
        { name: 'nonClinVal', desc: 'Non-Clinical Validation' }];
      this.resetAnalysis();
    });

    this.analysisFormGroup.get('analysisType').valueChanges.subscribe(() => {
      this.resetFPR();
    });

    this.analysisFormGroup.get('adaWorkflowType').valueChanges.subscribe(workflowType => {
      this.fprOptions = workflowType === 'nonClinVal' ? ['0.1%', '1%'] : ['5%', '1%'];
      this.resetFPR();
    });
    // console.log(this.Groups);
  }


  createForm() {

    this.analysisFormGroup = this.formBuilder.group({
      calcType: [null],
      analysisType: [null],
      assayType: [null],
      adaWorkflowType: [null],
      nabWorkflowType: [null],
      nabCPType: [null],
      screenAddMult: ['mult'],
      assayAddMult: ['mult'],
      adaSensType: [null],
      nabSensType: [null],
      nabType: [null],
      analyteName: [''],
      projectCode: [''],
      studyCode: [''],
      screeningCutpoint: [null, [Validators.pattern('^[0-9]+([.][0-9]+)?$')]],
      confirmatoryCutpoint: [null, [Validators.pattern('^\-?[0-9]+([.][0-9]+)?$')]],
      miCutpoint: [null, [Validators.pattern('^[0-9]+([.][0-9]+)?$')]],
      nmiCutpoint: [null, [Validators.pattern('^\-?[0-9]+([.][0-9]+)?$')]],
      cvThreshold: ['20', [Validators.required, Validators.pattern('^[0-9]+([.][0-9]+)?$'), Validators.min(0), Validators.max(100)]],
      useConfidenceInterval: ["false"],
      fpr: ['1%'],
      regressionType: ['4PL'],
//       concentrationUnit: [null],
      // negativeControlValues: ['Yes'],
//       regressionType: [''],
//       nabDataset: ['No'],
//       matrixInterference: [null],
//       NCMethod: ['GM'],
//       FPR: ['5%'],
//       decimalPoints: ['2'],
//       outlierRemoval: ['All'],
//       autoLogTransform: ['False'],
//       LPCCriticalvalue: ['t0.01'],
//       regType: ['4pl'],
//       filterNC: ['False'],
//       filterSensitivity: ['True'],
//       logFunc: ['natural log'],
//       NCReps: ['Mean of Means'],
//       NCThreshold: ['20'],
//       NCOutlierOption: ['False'],
//       sensThreshold: ['20'],
    })

    this.ref.detectChanges();
  }


  //   isValidInput(fieldName): boolean {
  //     return this.analysisFormGroup.controls[fieldName].invalid &&
  //       (this.analysisFormGroup.controls[fieldName].dirty || this.analysisFormGroup.controls[fieldName].touched);
  // }
  // isValidInput2(fieldName): boolean {
  //   return this.analysisFormGroup_ADA.controls[fieldName].invalid &&
  //     (this.analysisFormGroup_ADA.controls[fieldName].dirty || this.analysisFormGroup_ADA.controls[fieldName].touched);
  // }
  // isValidInput3(fieldName): boolean {
  //   return this.analysisFormGroup_RSG.controls[fieldName].invalid &&
  //     (this.analysisFormGroup_RSG.controls[fieldName].dirty || this.analysisFormGroup_RSG.controls[fieldName].touched);
  // }

  get formControls() { return this.analysisFormGroup.controls; }

  resetFPR() {
    if (this.analysisFormGroup.value.analysisType === 'QV' &&
        this.analysisFormGroup.value.adaWorkflowType == 'nonClinVal') {
      this.analysisFormGroup.patchValue({fpr: '0.1%'})
    } else {
      this.analysisFormGroup.patchValue({fpr: '5%'})
    }
  }

  showFPR() {
    if (this.analysisFormGroup.value.analysisType === 'QV' &&
        this.analysisFormGroup.value.assayType === 'ADA') {
      return true
    }
    return false
  }


  onSubmit(post) {
//     console.log('Submit for Analysis')
    this.analysisDetails = Object.assign({}, this.analysisFormGroup.value);
    this.analysisDetails.userId = this.signedInUser.username;
    this.analysisDetails.analysisId = (new Date).getTime().toString();
    this.post = post;
  }


  resetAnalysis() {
    this.analysisFormGroup.patchValue({
      analysisType: null,
      assayType: null
    })
  }

  getDisplayString(key) {
    return this.dropDownService.nameDescMap.get(key);
  }

  getDropDownValues(key) {
    return this.dropDownService.dropDownsMap.get(key);
  }

  ppssToDisplay() {
    // Simulate your async call to ppssService
    setTimeout(() => {
      const control = this.analysisFormGroup.controls.tukeyCoefficient as FormArray;
    }, 200)
  }




}
